<template>
  <div>
    <viewer
      hidden
      :options="options"
      :images="image"
      @inited="inited"
      class="viewer"
      ref="viewer"
    >
      <template slot-scope="scope">
        <img v-for="src in scope.images" :src="src" :key="src" />
        {{ scope.options }}
      </template>
    </viewer>
    <v-btn
      :color="color"
      :text="text"
      :small="$vuetify.breakpoint.lgAndUp"
      class="mt-2 text-capitalize v-btn--has-bg"
      @click="showSampleBill()"
      >Personal Property Tax Bill
      <v-icon :small="$vuetify.breakpoint.lgAndUp"
        >mdi-information</v-icon
      ></v-btn
    >
  </div>
</template>

<script>
import '@/plugins/viewer'
const sampleBill = require('@/assets/img/PersonalPropertyTaxBill.png')
export default {
  props: {
    color: {
      type: String,
      default: 'success'
    },
    text: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    image: [sampleBill],
    options: {
      navbar: false,
      title: false,
      toolbar: false
    }
  }),
  methods: {
    showSampleBill() {
      this.$viewer.show()
    },
    inited(viewer) {
      this.$viewer = viewer
    }
  }
}
</script>

<style></style>
